import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "saa-reflection-questions",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "saa-reflection-questions" */ "./components"
    ).then(importedModule => {
      const component = importedModule.default;
      return component;
    })
  ),
});
